function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.462 6c4.006 0 7.71 3.64 7.23 8.436-1.204 12.05-2.879 21.02-2.41 31.333.182 4.002-3.224 7.23-7.23 7.23h-2.41c-4.006 0-6.924-3.236-7.231-7.23 0 0-2.41-20.858-2.41-31.333C2 7.206 10.814 6 16.461 6z",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.205 32.513c1.291-6.234 4.091-12.332 10.846-18.077 4.239 5.104 8.118 10.235 7.954 15.667M14.051 14.436v-4.82"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.273 6c-4.006 0-7.71 3.64-7.23 8.436 1.204 12.05 2.879 21.02 2.41 31.333-.183 4.002 3.224 7.23 7.23 7.23h2.41c4.006 0 6.924-3.236 7.231-7.23 0 0 2.41-20.858 2.41-31.333C51.735 7.206 42.92 6 37.274 6z",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.529 32.513c-1.291-6.234-4.091-12.332-10.846-18.077-4.238 5.104-8.118 10.235-7.954 15.667M39.683 14.436v-4.82"
}));

var SvgFlipflops = function SvgFlipflops(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlipflops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flip flops.fa2978e1.svg";
export { ForwardRef as ReactComponent };